import { useState, useEffect, useRef } from "react";
import { Divider, Group, TextInput, Button, Paper, Text, Stack, Box, Title, Space } from "@mantine/core";
import { Card, message, Flex, Spin, Alert } from "antd";
import { useAuthContext } from "../../Hooks/UseAuthContext";
import { useReactToPrint } from "react-to-print";









const Boardofresolutionform = ({ rectification = false, stepData, submissionDetails, onSuccess }) => {
    const { user } = useAuthContext();
    const [submitloading, setSubmitloading] = useState(false);
    const [companyProfile, setCompanyProfile] = useState(null);
    const [compliancedetails, setCompliancedetails] = useState(null);
    const [banksdetails, setbanksdetails] = useState(null);
    const [merchantduedeligencedetails, setmerchantduedeligencedetails] = useState(null);
    const [boardMeetingDate, setBoardMeetingDate] = useState("");
    const componentRef = useRef(null);

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
    });


    const getUserData = async () => { // for get the updated user data after company profile submission
        await fetch('https://api.boompay.in/get-user', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`,
            }
        });
        // const data = await response.json();
        // if (response.status === 200) {
        //     // console.log(data.user);
        //     setUserprofile(data.user);
        //     setActive(data.user.Completed_step);
        //     setLoading(false);
        // } else if (response.status === 401) {
        //     setLoading(false);
        //     console.log('Unauthorized access. Please log in again.');
        //     message.error('Unauthorized access. Please log in again.');
        // } else if (response.status === 404) {
        //     setLoading(false);
        //     console.log('User not found.');
        //     message.error('User not found.');
        // } else {
        //     setLoading(false);
        //     console.log('An error occurred while fetching user data.');
        //     message.error('An error occurred while fetching user data.');
        // }
    }
    const handelSubmit = async () => {
        if (!boardMeetingDate) {
            message.error('Please enter the board meeting date before submitting the form.');
            return;
        }
        const resolutionContent = `
<div style="font-family: Times New Roman; line-height: 32px; color: #000;">

    <h3 style="text-align:center; text-transform:uppercase;">
        CERTIFIED TRUE COPY OF THE RESOLUTION PASSED IN THE MEETING OF
        BOARD OF DIRECTORS OF THE
    </h3>

    <h3 style="text-align:center; text-transform:uppercase;">
        ${companyProfile?.Company_name}
    </h3>

    <p>
        <strong>HELD ON</strong> ${boardMeetingDate}
        <strong> AT THE REGISTERED OFFICE - </strong>
        ${companyProfile?.Company_address}
    </p>

    <p style="text-align:justify;">
        <strong>RESOLVED THAT</strong> the consent of the Board of Directors
        be and is hereby accorded to enter into an agreement with
        <strong> BOOM PAY TECHNOLOGY Private Limited </strong>
        for availing Payment / Payout and any other ancillary services
        on such terms and conditions as specified in the agreement.
    </p>

    <p style="text-align:justify;">
        <strong>RESOLVED FURTHER THAT</strong> Mr./Ms.
        <strong>
            ${companyProfile?.Directors?.find(
            d => d.Is_Authroized_signatory
        )?.Director_name || ""}
        </strong>
        , Director / Authorized Signatory of the Company, be and
        is hereby authorized, severally, to sign and execute on behalf
        of the Company all agreements, undertakings, and any other
        necessary documents for availing the said services from
        <strong> BOOM PAY TECHNOLOGY Private Limited</strong>, and to do all
        such acts, deeds, and things as may be required to give effect
        to this resolution.
    </p>

    <p style="text-align:justify;">
        <strong>RESOLVED FURTHER THAT</strong> a certified true copy of
        this resolution be provided to any concerned authority or
        party as may be required.
    </p>

    <br/><br/>

    <p>
        <strong>CERTIFIED TRUE COPY</strong>
    </p>

    <br/><br/><br/>

    <div style="display:flex; justify-content:space-between; gap:20px; margin-top:50px;">
        ${companyProfile?.Directors?.map((director) => `
            <div style="text-align:center;">
                <div style="border-bottom:1px solid black; width:180px; margin-bottom:5px;"></div>

                <p style="margin:0;">
                    <strong>${director.Director_name}</strong>
                </p>

                <p style="margin:0;">
                    Director
                </p>
            </div>
        `).join("")}
    </div>

</div>
`;

        setSubmitloading(true);
        try {
            const response = await fetch('https://api.boompay.in/submit-board-of-resolution', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify({
                    Registered_Name_of_Company: companyProfile?.Company_name || "",
                    Registered_Office_Address: companyProfile?.Company_address || "",
                    Meeting_date: boardMeetingDate,
                    Directors_of_Company: companyProfile?.Directors || [],
                    Authorised_Signatory: companyProfile?.Directors?.filter(d => d.Is_Authroized_signatory).map(d => ({
                        Authorised_name: d.Director_name,
                        Authorised_mobile_number: d.Director_mobile_number,
                        Authorised_email: d.Director_email,
                        Authorised_DIN_number: d.Director_DIN_number,
                        Authorised_Share_perecentage: d.Share_perecentage,
                    })) || [],
                    Resolution_content: resolutionContent,
                    Bank_details_schema_id: banksdetails?._id,
                    Merchant_due_deligence_schema_id: merchantduedeligencedetails?._id,
                    Company_profile_schema_id: companyProfile._id,
                    Compliance_and_MAF_schema_id: compliancedetails._id,
                    Completed_step: 6, // Update the Completed_step to 6 after submitting Board resolution details 
                }),
            });
            const data = await response.json();
            if (response.status === 201) {
                console.log(data.message);
                getUserData();
                setSubmitloading(false);
                message.success(data.message);
            } else if (response.status === 401) {
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
                setSubmitloading(false);
            } else {
                console.log('An error occurred while submitting bank details.');
                message.error('An error occurred while submitting bank details.');
                setSubmitloading(false);
            }
        } catch (error) {
            console.error('Error:', error);
            message.error('An unexpected error occurred. Please try again later.');
            setSubmitloading(false);
        }
    }

    const handleRectificationSubmit = async () => {
        if (!boardMeetingDate) {
            message.error('Please enter the board meeting date before submitting the form.');
            return;
        }
        const resolutionContent = `
<div style="font-family: Times New Roman; line-height: 32px; color: #000;">

    <h3 style="text-align:center; text-transform:uppercase;">
        CERTIFIED TRUE COPY OF THE RESOLUTION PASSED IN THE MEETING OF
        BOARD OF DIRECTORS OF THE
    </h3>

    <h3 style="text-align:center; text-transform:uppercase;">
        ${companyProfile?.Company_name}
    </h3>

    <p>
        <strong>HELD ON</strong> ${boardMeetingDate}
        <strong> AT THE REGISTERED OFFICE - </strong>
        ${companyProfile?.Company_address}
    </p>

    <p style="text-align:justify;">
        <strong>RESOLVED THAT</strong> the consent of the Board of Directors
        be and is hereby accorded to enter into an agreement with
        <strong> BOOM PAY TECHNOLOGY Private Limited </strong>
        for availing Payment / Payout and any other ancillary services
        on such terms and conditions as specified in the agreement.
    </p>

    <p style="text-align:justify;">
        <strong>RESOLVED FURTHER THAT</strong> Mr./Ms.
        <strong>
            ${companyProfile?.Directors?.find(
            d => d.Is_Authroized_signatory
        )?.Director_name || ""}
        </strong>
        , Director / Authorized Signatory of the Company, be and
        is hereby authorized, severally, to sign and execute on behalf
        of the Company all agreements, undertakings, and any other
        necessary documents for availing the said services from
        <strong> BOOM PAY TECHNOLOGY Private Limited</strong>, and to do all
        such acts, deeds, and things as may be required to give effect
        to this resolution.
    </p>

    <p style="text-align:justify;">
        <strong>RESOLVED FURTHER THAT</strong> a certified true copy of
        this resolution be provided to any concerned authority or
        party as may be required.
    </p>

    <br/><br/>

    <p>
        <strong>CERTIFIED TRUE COPY</strong>
    </p>

    <br/><br/><br/>

    <div style="display:flex; justify-content:space-between; gap:20px; margin-top:50px;">
        ${companyProfile?.Directors?.map((director) => `
            <div style="text-align:center;">
                <div style="border-bottom:1px solid black; width:180px; margin-bottom:5px;"></div>

                <p style="margin:0;">
                    <strong>${director.Director_name}</strong>
                </p>

                <p style="margin:0;">
                    Director
                </p>
            </div>
        `).join("")}
    </div>

</div>
`;
        setSubmitloading(true);
        try {
            const response = await fetch('https://api.boompay.in/put/rectify/board-resolution', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify({
                    Registered_Name_of_Company: companyProfile?.Company_name || "",
                    Registered_Office_Address: companyProfile?.Company_address || "",
                    Meeting_date: boardMeetingDate,
                    Directors_of_Company: companyProfile?.Directors || [],
                    Authorised_Signatory: companyProfile?.Directors?.filter(d => d.Is_Authroized_signatory).map(d => ({
                        Authorised_name: d.Director_name,
                        Authorised_mobile_number: d.Director_mobile_number,
                        Authorised_email: d.Director_email,
                        Authorised_DIN_number: d.Director_DIN_number,
                        Authorised_Share_perecentage: d.Share_perecentage,
                    })) || [],
                    Resolution_content: resolutionContent,
                    Company_profile_schema_id: submissionDetails?.Company_profile_schema_id
                })
            });
            const data = await response.json();
            if (response.status === 201) {
                //console.log(data.message);
                message.success(data?.message)
                onSuccess(); // Refresh user data to update.
                setSubmitloading(false);
            } else if (response.status === 400) {
                message.error(data.message);
                console.log(data.message);
            } else if (response.status === 401) {
                message.error('Unauthorized access. Please log in again.');
                console.log('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                message.error('User not found.');
                console.log('User not found.');
            } else {
                message.error('An error occurred while submitting company profile.');
                console.log('An error occurred while submitting company profile.');
            }
        } catch (error) {
            message.error('An error occurred while submitting company profile.');
            console.error('Error:', error);
        }
        setSubmitloading(false);
    }

    useEffect(() => {
        const getCompanyProfile = async () => {
            const response = await fetch('https://api.boompay.in/get-company-profile', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                //console.log(data.Companyprofile);
                setCompanyProfile(data.Companyprofile);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Company profile not found.');
                message.error('Company profile not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getComplianceandmaf = async () => {
            const response = await fetch('https://api.boompay.in/get-compliance-details-and-maf', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Complianceandmafdetails);
                setCompliancedetails(data.Complianceandmafdetails);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Compliance details not found.');
                message.error('Compliance details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getbanksdetails = async () => {
            const response = await fetch('https://api.boompay.in/get-bank-details', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setbanksdetails(data.Banksdetails);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Banks details not found.');
                message.error('Banks details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getmerchantduedeligence = async () => {
            const response = await fetch('https://api.boompay.in/get-merchant-due-deligence', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setmerchantduedeligencedetails(data.Merchantduedeligence);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Merchant details not found.');
                message.error('Merchant details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }

        if (user) {
            getCompanyProfile();
            getComplianceandmaf();
            getbanksdetails();
            getmerchantduedeligence();
        }
    }, [user])

    useEffect(() => {
        const getUserData = async () => {
            setSubmitloading(true);
            const response = await fetch('https://api.boompay.in/get-submitted-details-for-rectification', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            //console.log(data);

            if (response.status === 200) {
                const profile = data.RectificationDetails.Board_of_resolution_schema_id;
                // Bank Details
                setBoardMeetingDate( profile.Meeting_date || '');
                setSubmitloading(false);
            } else if (response.status === 401) {
                setSubmitloading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                setSubmitloading(false);
                console.log('User not found.');
                message.error('User not found.');
            } else {
                setSubmitloading(false);
                console.log('An error occurred while fetching user data.');
                message.error('An error occurred while fetching user data.');
            }
        }

        if (user && rectification) {
            getUserData();
        }
    }, [user, rectification])
    return (
        <>
            <Flex gap="medium" vertical>
                <Spin spinning={submitloading} size="large" description="Please wait...">
                    <Card title="Board of resolution" style={{ "box-shadow": "rgba(0, 0, 0, 0.24) 0px 3px 8px", }}>
                        <Alert type="warning" title="Please fill in all the required details as instructed. After completing the form, download the document and upload the signed copy on the company letterhead, duly stamped and signed by the all directors and authorized signatory." showIcon />
                        <Group mt={'xs'}>
                            <TextInput label="Company name" value={companyProfile?.Company_name || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company CIN number" value={companyProfile?.Company_CIN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company PAN number" value={companyProfile?.Company_PAN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="GST number" value={companyProfile?.Company_GST_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="MSME number" value={companyProfile?.Company_MSME_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company address" value={companyProfile?.Company_address || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company mobile number" value={companyProfile?.Company_Mobile_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company email id" value={companyProfile?.Company_email || ""} disabled radius="xs" size="md" />
                        </Group>
                        <Divider label="Board of resolution" my="sm" variant="dashed" labelPosition="center" />
                        <Paper
                            withBorder
                            shadow="xs"
                            p="xl"
                            radius="md"
                            style={{
                                backgroundColor: "#fff",
                                fontFamily: "Times New Roman",
                                lineHeight: "32px",
                                color: "#000",
                            }}
                            ref={componentRef}
                        >
                            <Stack gap="md">

                                <Title order={4} ta="center" fw={700} tt="uppercase">
                                    CERTIFIED TRUE COPY OF THE RESOLUTION PASSED IN THE MEETING OF
                                    BOARD OF DIRECTORS OF THE
                                </Title>

                                <Text ta="center" fw={700} tt="uppercase">
                                    {companyProfile?.Company_name}
                                </Text>

                                <Group gap={5} align="end" wrap="wrap">
                                    <Text fw={600}>
                                        HELD ON
                                    </Text>

                                    <TextInput
                                        variant="unstyled"
                                        placeholder="Enter Meeting Date"
                                        value={boardMeetingDate}
                                        onChange={(e) => setBoardMeetingDate(e.target.value)}
                                        styles={{
                                            input: {
                                                borderBottom: "1px solid black",
                                                borderRadius: 0,
                                                minWidth: "200px",
                                                paddingBottom: "2px",
                                                textAlign: 'center'
                                            }
                                        }}
                                    />

                                    <Text fw={600}>
                                        AT THE REGISTERED OFFICE -
                                    </Text>

                                    <Text span fw={600}>
                                        {companyProfile?.Company_address}
                                    </Text>
                                </Group>

                                <Text ta="justify">
                                    <strong>“RESOLVED THAT</strong> the consent of the Board of Directors
                                    be and is hereby accorded to enter into an agreement with
                                    <strong> BOOM PAY TECHNOLOGY Private Limited </strong>
                                    for availing Payment / Payout and any other ancillary services
                                    on such terms and conditions as specified in the agreement.
                                </Text>

                                <Text ta="justify">
                                    <strong>RESOLVED FURTHER THAT</strong> Mr./Ms.
                                    <strong>
                                        {" "}
                                        {companyProfile?.Directors?.find(d => d.Is_Authroized_signatory)?.Director_name || ""}
                                    </strong>
                                    , Director / Authorized Signatory of the Company, be and
                                    is hereby authorized, severally, to sign and execute on behalf
                                    of the Company all agreements, undertakings, and any other
                                    necessary documents for availing the said services from
                                    <strong> BOOM PAY TECHNOLOGY Private Limited</strong>, and to do all
                                    such acts, deeds, and things as may be required to give effect
                                    to this resolution.
                                </Text>

                                <Text ta="justify">
                                    <strong>RESOLVED FURTHER THAT</strong> a certified true copy of
                                    this resolution be provided to any concerned authority or
                                    party as may be required.”
                                </Text>

                                <Space h="xl" />

                                <Text fw={700}>
                                    CERTIFIED TRUE COPY
                                </Text>

                                <Space h={40} />

                                <Group justify="space-between" align="flex-start" mt="xl">

                                    {companyProfile?.Directors.map((director, index) => (
                                        <Stack key={index} gap={1} align="center">
                                            <Box
                                                style={{
                                                    width: "180px",
                                                    borderBottom: "1px solid black",
                                                    marginBottom: "5px"
                                                }}
                                            />

                                            <Text fw={600} size="sm">
                                                {director?.Director_name}
                                            </Text>

                                            <Text size="xs">
                                                Director
                                            </Text>
                                        </Stack>
                                    ))}

                                </Group>

                            </Stack>
                        </Paper>
                        {/* {banks.map((bank, index) => (
                            <Group key={index} mt={'lg'}>
                                <TextInput
                                    label="Bank name"
                                    value={bank.bank_name}
                                    onChange={(e) => handleChange(index, "bank_name", e.target.value)}
                                    required
                                    variant="filled"
                                    radius="xs"
                                    size="md"
                                />

                                <TextInput
                                    label="Account number"
                                    value={bank.account_number}
                                    onChange={(e) => handleChange(index, "account_number", e.target.value)}
                                    required
                                    variant="filled"
                                    radius="xs"
                                    size="md"
                                />

                                <TextInput
                                    label="IFSC code"
                                    value={bank.ifsc_code}
                                    onChange={(e) => handleChange(index, "ifsc_code", e.target.value)}
                                    required
                                    variant="filled"
                                    radius="xs"
                                    size="md"
                                />

                                <TextInput
                                    label="Branch"
                                    value={bank.bank_branch}
                                    onChange={(e) => handleChange(index, "bank_branch", e.target.value)}
                                    required
                                    variant="filled"
                                    radius="xs"
                                    size="md"
                                />

                                <Button mt="xs" onClick={addBanks} size="xs" variant="light">
                                    + Add Bank
                                </Button>
                                {banks.length > 1 && (
                                    <Button
                                        mt="xs"
                                        color="red"
                                        variant="light"
                                        onClick={() => removeBanks(index)}
                                        size="xs"
                                    >
                                        - Remove Bank
                                    </Button>
                                )}
                            </Group>
                        ))} */}
                        <Group justify="end">
                            <Button mt={'md'} size="lg" color="teal" variant="light" onClick={handlePrint}>Print Board of resolution </Button>
                            {/* <Button mt={'md'} size="lg" color="lime" variant="light" onClick={handelSubmit} loading={submitloading}>Save changes</Button> */}
                            <Button
                                mt={'md'}
                                size="lg"
                                color="lime"
                                variant="light"
                                loading={submitloading}
                                onClick={
                                    rectification
                                        ? handleRectificationSubmit
                                        : handelSubmit
                                }
                            >
                                {
                                    rectification
                                        ? "Submit Rectification"
                                        : "Save Changes"
                                }
                            </Button>
                        </Group>

                    </Card>
                </Spin>
            </Flex>

        </>
    )
}
export default Boardofresolutionform